var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-toggle-button" }, [
    _c("div", {}, [
      _c("div", {}, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-toggle active",
            attrs: {
              type: "button",
              "data-toggle": "button",
              "aria-pressed": "true",
              autocomplete: "off",
              "aria-label": "Toggle theme between light and dark mode"
            },
            on: { click: _vm.toggleTheme }
          },
          [_c("div", { staticClass: "handle" })]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1e95852", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1e95852","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeTogglerButton.vue
// module id = null
// module chunks = 